'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Checkable;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getComponentName = require('react-utils/getComponentName');

var _getComponentName2 = _interopRequireDefault(_getComponentName);

var _useChecked2 = require('../hooks/useChecked');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Similar to `Controllable`, but specifically for controlling a `checked` property using the same
 * API as native checkbox/radio inputs: `checked`, `defaultChecked`, and `onChange`. Additionally,
 * the events passed to `onChange` use `evt.target.checked` instead of `evt.target.value`.
 *
 * @param {JSX.Component} Component
 * @returns {JSX.Component} A component with defaultable `checked` prop
 */
function Checkable(Component) {
  var CheckableComponent = (0, _react.forwardRef)(function (props, ref) {
    var __checked = props.checked,
        __defaultChecked = props.defaultChecked,
        __onChange = props.onChange,
        rest = _objectWithoutProperties(props, ['checked', 'defaultChecked', 'onChange']);

    // eslint-disable-next-line react-hooks/rules-of-hooks


    var _useChecked = (0, _useChecked2.useChecked)(props),
        checked = _useChecked.checked,
        onChange = _useChecked.onChange;

    return _react2.default.createElement(Component, _extends({}, rest, { checked: checked, onChange: onChange, ref: ref }));
  });

  CheckableComponent.propTypes = _extends({}, Component.propTypes, _useChecked2.checkedPropTypes);

  CheckableComponent.defaultProps = _extends({}, Component.defaultProps, {
    defaultChecked: Component.defaultProps && Component.defaultProps.checked != null ? Component.defaultProps.checked : false
  });
  delete CheckableComponent.defaultProps.checked;

  CheckableComponent.displayName = 'Checkable(' + (0, _getComponentName2.default)(Component) + ')';

  (0, _utils.attachWrappedComponent)(CheckableComponent, Component);

  return CheckableComponent;
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/decorators/Checkable.js
// module id = 577
// module chunks = 177